import { useMemo } from 'react';
import { FCX, Tooltip, useUuid } from '@datassential/platform-ui-lib';
import cn from 'classnames';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { useTerritorySelection } from '@pages/Home/context/TerritorySelectionContext';
import { useHomeTerritoryOptions } from '@pages/Home/context/TerritoryOptionsContext';
import { buildSummaryText } from '@pages/Home/sections/HomeTerritoryOptions/HomeTerritoryOptions.helpers';
import { SCOPE_MY_TERRITORY, SCOPE_TOTAL_US } from '@pages/Home/sections/HomeLandscape/HomeLandscape.constants';
import './TerritoryScopeLabel.scss';

const TerritoryScopeLabel: FCX = ({ className, testId }) => {
    const { savedSelection } = useTerritorySelection();
    const { states, metros, isLoading } = useHomeTerritoryOptions();
    const tooltipId = useUuid();

    const hasTerritory = Boolean(savedSelection?.ids.length);

    const summaryText = useMemo(
        () => buildSummaryText(savedSelection, { states, metros }),
        [savedSelection, states, metros],
    );

    const showInfo = hasTerritory && !isLoading && summaryText.length > 0;

    return (
        <span className={cn('TerritoryScopeLabel', className)} data-testid={testId}>
            {hasTerritory ? SCOPE_MY_TERRITORY : SCOPE_TOTAL_US}
            {showInfo && (
                <>
                    <button
                        type="button"
                        className="TerritoryScopeLabel__info"
                        data-tooltip-id={tooltipId}
                        aria-label={`Show selected ${savedSelection?.mode === 'metro' ? 'metros' : 'states'}`}
                    >
                        <AiOutlineInfoCircle />
                    </button>
                    <Tooltip id={tooltipId} place="right" style={{ zIndex: 10, maxWidth: 320 }}>
                        {summaryText}
                    </Tooltip>
                </>
            )}
        </span>
    );
};

export default TerritoryScopeLabel;
